/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSVersicherungsbeitraegeSearchresultDTO from '../../models/TSVersicherungsbeitraegeSearchresultDTO';
import TSVersicherungsbeitrag from '../../models/TSVersicherungsbeitrag';

export default class VersicherungsbeitragRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log', '$q'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService, private $q: IQService) {
        this.serviceURL = REST_API + 'versicherungsbeitraege';
        this.http = $http;
    }

    public searchVersicherungsbeitraege(versicherungsbeitragSearch: any): IPromise<TSVersicherungsbeitraegeSearchresultDTO> {

        return this.http.post(this.serviceURL + '/search/', versicherungsbeitragSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING versicherungsbeitragDTO REST array object', response.data);
            return new TSVersicherungsbeitraegeSearchresultDTO().deserialize(response.data);
        });
    }

    public findVersicherungsbeitrag(versicherungsbeitragID: string): IPromise<TSVersicherungsbeitrag> {
        return this.http.get(this.serviceURL + '/' + encodeURIComponent(versicherungsbeitragID))
            .then((response: any) => {
                this.$log.debug('PARSING versicherungsbeitrag REST object ', response.data);
                return new TSVersicherungsbeitrag().deserialize(response.data);
            });
    }

    public update(versicherungsbeitrag: TSVersicherungsbeitrag): IPromise<TSVersicherungsbeitrag> {
        let vsToSend = {};
        vsToSend = versicherungsbeitrag.serialize(vsToSend);

        this.$log.debug('sending Versicherungsbeitrag:');
        this.$log.debug(vsToSend);

        return this.http.put(this.serviceURL, vsToSend, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            return new TSVersicherungsbeitrag().deserialize(response.data);
        });
    }


    public deleteBeitrag(versicherungsbeitragId: any): IPromise<any> {
        return this.http.delete(this.serviceURL + '/deleteBeitrag/' + encodeURIComponent(versicherungsbeitragId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/versicherungsbeitragRS.rest.ts